<template>
  <modal
    v-if="show"
    width="920px"
    bodyOverflow="auto"
    height="800px"
    :title="activeId ? t('Edit Bot Detection Rules') : t('Create Bot Detection Rules')"
    @close="checkClose"
    :read-article-url="`https://docs.bemob.com/${locale}/bot-detection-rules`"
  >
    <rule-settings
      ref="ruleSettingsRef"
      :rule="activeRule"
      v-model:active_name="activeName"
      v-model:relation="relation"
      :errorsName="errors.length ? errorsDict['name'] : undefined"
    />

    <template #footer>
      <section class="d-flex justify-space-between align-center xs12 error-wrapper w100">
        <error-aggregator
          v-model="errors"
          v-model:active="errorsControlActive"
        />

        <div class="d-flex justify-end">
          <ui-button
            :text="t('Cancel')"
            icon="fas fa-times"
            @click="checkClose"
          />

          <ui-button
            data-action="save"
            :text="t('Save')"
            icon="fas fa-check"
            button-style="accent"
            @click="save"
          />
        </div>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';
import RuleSettings from './rule-settings.vue';
import { useAddBotDetectionRules } from './useAddBotDetectionRules';

const props = defineProps<{
  data?: {
    id?: string;
  };
}>();

const emit = defineEmits<{
  close: [];
  save: [];
}>();

const ruleSettingsRef = ref<InstanceType<typeof RuleSettings> | null>(null);

const {
  t,
  locale,
  show,
  activeName,
  activeId,
  activeRule,
  relation,
  errors,
  errorsControlActive,
  errorsDict,
  checkClose,
  save,
} = useAddBotDetectionRules(props.data || {}, () => emit('close'), () => emit('save'));

onMounted(() => {
  nextTick(() => {
    if (!ruleSettingsRef.value) {
      return;
    }

    ruleSettingsRef.value.conditions.forEach((item) => {
      item.selected = false;
    });
    ruleSettingsRef.value.resetValidation();
  });
});
</script>

<style lang="scss" scoped>
.error-wrapper {
  .d-flex > * {
    flex: 0 1 auto !important;
  }
}

.add-bot-detection-rules-dialog {
  height: 100%;
  max-height: 863px !important;

  :deep(.v-card) {
    height: 100%;
    max-height: 863px;
  }

  &__rules-wrapper {
    background-color: var(--color-gray5);
  }

  &__rules-container {
    padding: 24px;
    max-height: 100%;

    .flow-details__inp-name {
      label {
        font-size: 17px !important;
      }
    }

    .connection-type__radio-gr {
      margin-top: 0;
    }

    :deep(.v-select) {
      label.v-label {
        font-size: 17px !important;
      }
    }
  }
}
</style>
